import React from 'react'

import img from 'assets/images/productionPage/things.png'

import classes from './Requirements.module.scss'

export const Requirements = (): JSX.Element => {
  const renderList = () => {
    const items = [
      'Правообладатель или автор интересных сценарных материалов',
      'Представитель российских или зарубежных продакшн-компаний',
    ]

    return (
      <ol className={classes.list}>
        {items.map((text, i) => (
          <li key={i} className={`${classes.list__item} mt-1`}>
            {text}
          </li>
        ))}
      </ol>
    )
  }
  return (
    <div
      className={`${classes.container} container reveal-from-bottom-medium`}
      data-reveal-delay={30}
    >
      <img src={img} alt="" className={classes.img} />
      <div className="row">
        <div className="col-xs-12 col-lg-6 col-lg-offset-6">
          <h2 className={`${classes.title} second-title uppercase`}>
            Мы рассмотрим <br /> партнерство <br /> в производстве, <br /> если
            вы:
          </h2>
          {renderList()}
        </div>
      </div>
    </div>
  )
}
